import { useLocation, useNavigate } from 'react-router-dom'
import { Home, Calendar, ClipboardList, Brain, Settings } from 'lucide-react'
import { hapticSelection } from '../lib/telegram'

const TABS = [
  { id: '/',         label: 'Главная',    Icon: Home },
  { id: '/calendar', label: 'Календарь',  Icon: Calendar },
  { id: '/tasks',    label: 'Задачи',     Icon: ClipboardList },
  { id: '/facts',    label: 'Память',     Icon: Brain },
  { id: '/settings', label: 'Настройки',  Icon: Settings },
] as const

export default function TabBarDirector() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const matchTab = (id: string) => id === '/' ? pathname === '/' : pathname.startsWith(id)

  return (
    <nav className="tabbar">
      {TABS.map(({ id, label, Icon }) => {
        const active = matchTab(id)
        return (
          <button
            key={id}
            className={`tabbar-item${active ? ' is-active' : ''}`}
            onClick={() => { if (!active) hapticSelection(); navigate(id) }}
          >
            <Icon />
            <span>{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
